import { memo } from '@morphic-ts/common/es6/utils';
import { ShowType, ShowURI } from '../hkt';
import { showApplyConfig } from './../config';
/**
 *  @since 0.0.1
 */
export const showIntersectionInterpreter = memo(() => ({
    _F: ShowURI,
    intersection: (...types) => (name, config) => (env) => {
        const shows = types.map(getShow => getShow(env).show);
        return new ShowType(showApplyConfig(config)({
            show: a => shows.map(s => s.show(a)).join(' & ')
        }, env, {
            shows
        }));
    }
}));
